import { render } from "./HeroImage.vue?vue&type=template&id=d978390c"
import script from "./HeroImage.vue?vue&type=script&lang=js"
export * from "./HeroImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__